<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">{{_modalHeader}}</span>
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
    </div>
    <div class="ttmodal__body">
        <span class="input-description">{{_modalDescription}}</span>
        <div class="input-container">
            <span class="label">{{_optionText}}<span class="red-text">*</span></span>
            <select [(ngModel)]="_assignData.AssignmentId" (ngModelChange)="selectionChanged($event)" class="get-select-text">
                <option value="0" disabled selected>{{_optionText}}</option>
                <option *ngFor="let access of _accessOptions" [value]="access.Id">{{access.Name}}</option>
            </select>
        </div>
        <div>
            <table class="table table--striped table--full-width">
                <thead>
                    <tr>
                        <th>
                            
                        </th>
                        <th>Name</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of _existingAccessList">
                        <td>
                            <i class="material-icons cursor-pointer" (click)="removeRelation(row.Id)">close</i>
                        </td>
                        <td>
                            {{row.Name}}
                        </td>
                    </tr>
                    </tbody>
                </table>
        </div>
    </div>
    <div style="color: red;" *ngIf="!customerNameValid">{{'There are duplicates customers for this dealerGroup'}}</div>
    <div class="ttmodal__footer">
        <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
        <button class="button button--primary" [disabled]="_buttonDiabled" (click)="onSubmit()" [class.loading]="submitting"><span class="button__text">{{_submitText}}</span></button>
    </div>
</div>
